// This holds Cookie Consent settings and Google Analytics settings. Uncomment if you need them.
import './ext';

document.addEventListener('DOMContentLoaded', function() {
    // Preload fonts
    const fonts = [
        { href: 'fonts/Byrd-ExtraBold.woff2', type: 'font/woff2' },
        { href: 'fonts/Byrd-ExtraBold.woff', type: 'font/woff' },
        { href: 'fonts/Byrd-Light.woff2', type: 'font/woff2' },
        { href: 'fonts/Byrd-Light.woff', type: 'font/woff' }
    ];

    fonts.forEach(font => {
        const preloadLinkFont = document.createElement('link');
        preloadLinkFont.rel = 'preload';
        preloadLinkFont.as = 'font';
        preloadLinkFont.href = font.href;
        preloadLinkFont.crossOrigin = 'anonymous';
        document.head.appendChild(preloadLinkFont);
    });

    // Hinweis: Das Hero-Video (why/why.webm, ~5,5 MB) wird vom <video autoPlay>
    // in Why.jsx ohnehin geladen. Ein zusätzliches Preload würde es ein zweites
    // Mal eager laden und die initiale Netzwerklast verdoppeln — daher bewusst
    // KEIN Video-Preload hier.
});
